import ChainIcon from '../components/Icons/ChainIcon';
import DataTransferIcon from '../components/Icons/DataTransferIcon';
import MailboxInIcon from '../components/Icons/MailboxInIcon';
import PaperEditIcon from '../components/Icons/PaperEditIcon';
import QrCodeIcon from '../components/Icons/QrCodeIcon';
import SavingBankIcon from '../components/Icons/SavingBankIcon';

// for country check on Add New Wire Withdrawal Account
export const USA_COUNTRY_LABEL = 'United States of America';

// bank accounts
export const METHOD_VIA_PLAID = 'via_plaid';
export const METHOD_VIA_CHECK = 'via_check';

// ira millenium
export const TYPE_DISTRIBUTION = 'distribution';
export const TYPE_TRANSFER_OUT = 'transferOut';

// ira types
export const TYPE_IRA_TO_IRA = 'IRA_TO_IRA';
export const TYPE_ROLLOVER_DEPOSIT = 'ROLLOVER_DEPOSIT';
export const TYPE_ANNUAL_IRA_CONTRIBUTION = 'ANNUAL_IRA_CONTRIBUTION';
export const IRA_EQUITY_TYPE = 'equity';
export const IRA_MILLENIUM_TYPE = 'millenium';

// ira fee withdrawal
export const TYPE_IRA_FEE_CHECK_WITHDRAWAL = 'IRAFeeCheckWithdrawal';
export const TYPE_IRA_FEE_CASH_WITHDRAWAL = 'IRAFeeCashWithdrawal';
export const TYPE_BUY_FOR_DELIVERY = 'BuyForDelivery';
export const IRA_FEE_WITHDRAWAL = 'IRAFeeWithdrawal';
export const IRA_EQUITY_TRUST_TYPE = 'Equity Trust';
export const IRA_ENTRUST_TYPE = 'Entrust';
export const TAB_TYPE_BANK_WIRE = 'Bank Wire';
export const TAB_TYPE_CHECK = 'Check';
// document types
export const DT_IRA_PREFUNDED_CHECK_DEPOSIT =
  'IRAPrefundedCheckDepositInstructions';
export const DT_IRA_PREFUNDED_WIRE_DEPOSIT =
  'IRAPrefundedWireDepositInstructions';
export const DT_IRA_ANNUAL_CONTRIB_CHECK_DEPOSIT =
  'IRAAnnualContributionCheckDepositInstructions';
export const DT_IRA_ANNUAL_CONTRIB_WIRE_DEPOSIT =
  'IRAAnnualContributionWireDepositInstructions';
export const DT_IRA_TRANSFER_FORM = 'IRATransferForm';
export const DT_IRA_ROLLOVER = 'IRARolloverInstructions';

export const IRA_DISTRIBUTION_REQUEST_FORM =
  'https://www.mtrustcompany.com/sites/default/files/forms/static/IRA_Distribution_Request.pdf';

export const IRA_TO_IRA_TRANSFER = 'IRA to IRA Transfer';
export const ROLLOVER_DEPOSIT = 'Rollover Deposit';
export const ANNUAL_IRA_CONTRIBUTION = 'Annual IRA Contribution';
export const ACH_DEPOSIT = 'ACH Deposit';
export const WIRE_DEPOSIT = 'Wire Deposit';
export const CHECK_DEPOSIT = 'Check Deposit';
export const IRA_DISTRIBUTION = 'IRA Distribution';
export const IRA_TRANSFER_OUT = 'IRA Transfer Out';
export const WIRE_WITHDRAWAL = 'Wire Withdrawal';
export const CHECK_WITHDRAWAL = 'Check Withdrawal';

export const APPLICATION_TYPE = {
  1: 'Individual',
  2: 'Corporate',
  3: 'IRA',
  4: 'JointTenants',
  5: 'UTMA',
};

export const APPLICATION_TYPE_STRING_KEYS = {
  Individual: 'Individual',
  Corporate: 'Corporate',
  IRA: 'IRA',
  JointTenants: 'JointTenants',
  UTMA: 'UTMA',
};

export const APPLICATION_TYPE_STRING = {
  1: 'IndividualApplication',
  2: 'CorporateApplication',
  3: 'IRAApplication',
  4: 'JointTenantsApplication',
  5: 'UTMAApplication',
};

export const ACCOUNT_TYPES = {
  CorporateApplication: {
    1: 'Corporate',
    2: 'SoleProprietorship',
    3: 'LimitedLiabilityCorporation',
    4: 'Trust',
    5: 'Partnership',
  },
  IRAApplication: {
    1: 'Traditional',
    2: 'Roth',
    3: 'SIMPLE',
    4: 'SEP',
  },
  JointTenantsApplication: {
    1: 'Common',
    2: 'WithRightOfSurvivorship',
  },
  UTMAApplication: {
    1: 'Custodian',
    2: 'Trustee',
  },
};

export const CorporateAccountType = {
  1: 'Corporate',
  2: 'SoleProprietorship',
  3: 'LimitedLiabilityCorporation',
  4: 'Trust',
  5: 'Partnership',
};

export const IRAAccountType = {
  1: 'Traditional',
  2: 'Roth',
  3: 'SIMPLE',
  4: 'SEP',
};

export const JointTenantsAccountType = {
  1: 'Common',
  2: 'WithRightOfSurvivorship',
};

export const UTMAAccountType = {
  1: 'Custodian',
  2: 'Trustee',
};

export const APPLICANT_TYPES = {
  MAIN: 'main',
  SECONDARY: 'secondary',
  MINOR: 'minor',
  BUSINESS: 'business',
  JOINT: 'joint',
};

export const REGISTRATION_FLOW_TYPES = {
  REGULAR: 'Regular',
  AIP: 'Aip',
};

export const REGISTRATION_FLOWS = {
  1: 'Regular',
  2: 'Aip',
};

export const DOCUMENT_TYPES = {
  DRIVERS_LICENSE: 'DriversLicense',
  PASSPORT: 'Passport',
  GOVERNMENT_ID: 'GovernmentId',
  CREDIT_CARD: 'CreditCard',
  UTILITY_BILL: 'UtilityBill',
  BANK_STATEMENT: 'BankStatement',
  SOCIAL_SECURITY_CARD: 'SocialSecurityCard',
  MEDIACARE_CARD: 'MediacareCard',
  VOIDED_CHECK: 'VoidedCheck',
};

export const APPLICATION_FUNDING_TYPE = [
  'ACHConnected',
  'ACHManual',
  'Wire',
  'Check',
  'Cryptocurrency',
];

export const APPLICATION_MARTIAL_STATUS_TYPE = [
  'Single',
  'Married',
  'Divorced',
  'Widowed',
];

export const IRA_APPLICATION_FUNDING_TYPES = [
  'IRATransfer',
  'Rollover',
  'AnnualContribution',
];

export const IRA_ACCOUNT_TYPES = ['Traditional', 'Roth', 'Simple', 'Sep'];

export const IRA_TRANSFER_TYPES = [
  'Inkind',
  'Liquidate',
  'Partial',
  'Partial In Kind Cash',
  'Partial Cash',
  'Partial In Kind',
];

export const AGREEMENT_TYPES = {
  HAA: 'HAA',
  ACH: 'ACH',
  IRA: 'IRA',
  METAL_STREAM: 'METAL_STREAM',
};

export const EDIT_IRA_FUNDING_TYPES = {
  fundingType: 'EditFundingType',
  fundingAmount: 'EditFundingAmount',
};

export const METAL_STREAM_REQUEST = {
  Amount: 350,
  BankAccountUid: '',
  UseAccountBalance: true,
  GoldProductConfiguration: {
    SymbolCode: 'FGSOK-HAA',
    Percentage: 0.65,
  },
  SilverProductConfiguration: {
    SymbolCode: 'FSPHZ-HAA',
    Percentage: 0.35,
  },
};

export const FUND_TYPE_METAL = 'metal';
export const fundMetalOptions = [
  {
    title: 'fundAccount.addMetalBankTitle',
    description: 'fundAccount.addMetalBankDescription',
    recommended: true,
    Icon: ChainIcon,
    fundType: 'plaid',
  },
  {
    title: 'fundAccount.manualMetalTitle',
    description: 'fundAccount.manualMetalDescription',
    Icon: PaperEditIcon,
    showDivider: false,
    fundType: 'manual',
  },
];

export const FUND_TYPE_STANDARD = 'standard';
export const normalFundAccountOptions = [
  {
    title: 'fundAccount.addBankTitle',
    subtitle: 'fundAccount.addBankSubtitle',
    description: 'fundAccount.addBankDescription',
    recommended: true,
    Icon: SavingBankIcon,
    fundType: 'plaid',
  },
  {
    title: 'fundAccount.wireTitle',
    subtitle: 'fundAccount.wireSubtitle',
    description: 'fundAccount.wireDescription',
    Icon: DataTransferIcon,
    fundType: 'wire',
  },
  {
    title: 'fundAccount.checkTitle',
    subtitle: 'fundAccount.checkSubtitle',
    description: 'fundAccount.checkDescription',
    Icon: MailboxInIcon,
    fundType: 'check',
  },
];

export const FUND_TYPE_RETIREMENT = 'retirement';
export const retirementFundOptions = [
  {
    title: 'fundAccount.transferIRATitle',
    subtitle: 'fundAccount.transferIraSubtitle',
    description: 'fundAccount.transferIRADescription',
    Icon: MailboxInIcon,
    fundType: 'transferIRA',
  },
  {
    title: 'fundAccount.rolloverTitle',
    subtitle: 'fundAccount.rolloverSubtitle',
    description: 'fundAccount.rolloverDescription',
    Icon: QrCodeIcon,
    fundType: 'rollover',
  },
  {
    title: 'fundAccount.cashTitle',
    subtitle: 'fundAccount.cashSubtitle',
    description: 'fundAccount.cashDescription',
    Icon: SavingBankIcon,
    showDivider: false,
    fundType: 'cash',
  },
];

export const suffixOptionsEnumerated = {
  None: 0,
  ESQ: 12,
  JR: 6,
  MD: 13,
  SR: 7,
  I: 1,
  II: 2,
  III: 3,
  IV: 4,
  V: 8,
  VI: 9,
  VII: 10,
  VIII: 11,
  IX: 5,
};

export const suffixOptions = [
  'None',
  'ESQ',
  'JR',
  'MD',
  'SR',
  'I',
  'II',
  'III',
  'IV',
  'V',
  'VI',
  'VII',
  'VIII',
  'IX',
];

export const suffixOptionsValues = {
  0: 'None',
  1: ' I',
  2: 'II',
  3: 'III',
  4: 'IV',
  8: 'V',
  9: 'VI',
  10: 'VII',
  11: 'VIII',
  5: 'IX',
  6: 'JR',
  7: 'SR',
  12: 'ESQ',
  13: 'MD',
};

export const PersonTargetType = {
  1: 'Primary',
  2: 'Secondary',
  3: 'Both',
};

export const PRODUCT_TYPE_SILVER = 'Silver';
export const PRODUCT_TYPE_GOLD = 'Gold';

export const KYC_DOCUMENT_TYPES = {
  1: 'Passport',
  2: 'DriverLicenseOrStateIssuedIDCard',
  3: 'DriverLicenseOrPassport',
  4: 'UtilityBill',
  5: 'BankStatement',
  6: 'SocialSecurityOrMedicareCard',
  7: 'VoidedCheck',
  10: 'Other',
};

export const Passport = 'Passport';
export const DriverLicenseOrStateIssuedIDCard =
  'DriverLicenseOrStateIssuedIDCard';
export const DriverLicenseOrPassport = 'DriverLicenseOrPassport';
export const UtilityBill = 'UtilityBill';
export const BankStatement = 'BankStatement';
export const SocialSecurityOrMedicareCard = 'SocialSecurityOrMedicareCard';
export const VoidedCheck = 'VoidedCheck';
export const Other = 'Other';

export const KYC_PERSON_TARGET_TYPES = ['Primary', 'Secondary', 'Both'];

export const PrimaryTargetType = 'Primary';
export const SecondaryTargetType = 'Secondary';
export const BothTargetType = 'Both';

export const KYC_SOCURE_DOCUMENT_TYPES = [
  'Passport',
  'License',
  'IdentificationCard',
];

export const BASIC_ACCOUNT_UPGRADE_TYPES = {
  NOT_UPGRADABLE: 1,
  IN_PROCESS: 2,
  UPGRADED: 3,
};

// Create new application
export const CREATE_NEW_APPLICATION = 'CreateNewApplication';
